module.exports = __webpack_public_path__ + "media/images/thumb--primary-f5e2aa667045462b0c967f8c034b6129.jpg";